import React, { FC } from 'react'
import Link from 'next/link'
import css from './Breadcrumbs.module.scss'
import { IBreadcrumb } from '../../../types'

const Breadcrumbs: FC<{ breadcrumbs: IBreadcrumb[] }> = ({ breadcrumbs }) => {
  if (!breadcrumbs) {
    return null
  }

  return (
    <div className={css.wrapper}>
      {breadcrumbs.map((crumb, index, { length }) => (
        <React.Fragment key={crumb?.id}>
          <Link href={crumb?.link} passHref>
            <a>{crumb.name}</a>
          </Link>
          {index < length - 1 && <span> / </span>}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Breadcrumbs
